;(function () {

"use strict";

var EntryView = require('./entry');

var SelectView = EntryView.extend({
  initialize: function (opts) {    
    EntryView.prototype.initialize.call(this, opts);
  }
});

module.exports = SelectView;

}());
